import axiosInstance from "@/api/axios";
type AddAllLeadsPayload =
  | {
    type: "byIds";
    leadIds: number[];
    stageId?: number
  }

  | {
    type: "byFilter";
    filters?: object;
    stageId?: number
    limit?: number
    sortBy?: string;
    sortOrder?: string;
    savedFilterId?: number

  }


// export const addAllLeadsToCRM = async (payload:AddAllLeadsPayload) => {

//   try {
//      let data;
//      let params;
//      console.log(payload,"line 16")

//     if (payload.type === "byIds") {
//       data = { leadIds: payload.leadIds,stageId: payload.stageId };
//     } else {

//         data = {
//         filters: payload.filters,
//         stageId: payload.stageId,
//         limit: payload.limit,
//         savedFilterId:payload.savedFilterId,
//         sortBy:payload.sortBy,
//       sortOrder:payload.sortOrder
//       };
//     }
//     const response = await axiosInstance({
//       method: "POST",
//       url: "/odoo/api/v1/projectLeads/saveMultipleLeads",
//       data,
//       params,
//     });
//     console.log("response", response);
//     return {
//       response: response.data.data,
//       payload
//     };
//   } catch (err) {
//     console.log("err", err);
//   } finally {
//     // setIsLoading(false); // Optionally handle loading state here
//   }
// };

export const getProjectLeadsListViewColumns = async () => {
  try {
    const response = await axiosInstance.get("/odoo/api/v1/projectLeads/listView");
    if (response.data?.data?.allColumns) {
      return response.data.data.allColumns;
      console.log("response644", response.data.data.allColumns); 
    } else {
      throw new Error("Invalid response structure");
    }
  } catch (error) {
    console.error("Error fetching CRM List View Columns:", error);
    throw error;
  }
};

export const addAllLeadsToCRM = async (payload: AddAllLeadsPayload) => {
  try {
    let data: Record<string, any> = {};

    if (payload.type === "byIds") {
      data = {
        leadIds: payload.leadIds,
        stageId: payload.stageId,
      };
    } else {
      const fullData = {
        filters: payload.filters,
        stageId: payload.stageId,
        limit: payload.limit,
        savedFilterId: payload.savedFilterId,
        sortBy: payload.sortBy,
        sortOrder: payload.sortOrder,
      };

      // Remove keys with empty values
      data = Object.fromEntries(
        Object.entries(fullData).filter(
          ([_, value]) =>
            value !== undefined &&
            value !== null &&
            value !== "" &&
            !(Array.isArray(value) && value.length === 0) &&
            !(typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0)
        )
      );

    }

    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/saveMultipleLeads",
      data,
    });
    console.log("response", response);
    return {
      response: response.data.data,
      payload,
    };
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const fetchSortingOptions = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/projectLeads/sortingOptions",
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const exportLeads = async (
  exportType: string,
  selectedLeadIds: Array<number>,
  exportKeys: Array<string>
) => {
  try {
    //  console.log(exportType,selectedLeadIds,exportKeys,"line 39")
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/export",
      data: {
        exportType,
        leadIds: selectedLeadIds,
        exportKeys: exportKeys,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const exportProjectLeads = async (
  exportType: string,
  selectedLeadIds: Array<number>,
  exportKeys: Array<string>
) => {
  try {
    console.log(exportType, selectedLeadIds, exportKeys, "----line 38");
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/export",
      data: {
        exportType,
        leadIds: selectedLeadIds,
        exportKeys: exportKeys,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const fetchFilterOptions = async (params: object) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/projectLeads/filters/v2",
      params: params,
    });
    return response.data;
  } catch (err) {
    console.log(err, "error");
  }
};

export const addToWatchList = async (builder_id: number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/builders/watchlist/add",
      data: {
        builder_id: builder_id, // Pass the array of lead IDs in the request body
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};

export const removeFromWatchList = async (builder_id: number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/builders/watchlist/remove",
      data: {
        builder_id: builder_id, // Pass the array of lead IDs in the request body
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false); // Optionally handle loading state here
  }
};
